import { render, staticRenderFns } from "./CurcuminExtract .vue?vue&type=template&id=04a14064&scoped=true&"
import script from "./CurcuminExtract .vue?vue&type=script&lang=js&"
export * from "./CurcuminExtract .vue?vue&type=script&lang=js&"
import style0 from "./CurcuminExtract .vue?vue&type=style&index=0&id=04a14064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a14064",
  null
  
)

export default component.exports